import { render, staticRenderFns } from "./VendorCardManage.vue?vue&type=template&id=b3a7b2b4&scoped=true"
import script from "./VendorCardManage.vue?vue&type=script&lang=js"
export * from "./VendorCardManage.vue?vue&type=script&lang=js"
import style0 from "./VendorCardManage.vue?vue&type=style&index=0&id=b3a7b2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a7b2b4",
  null
  
)

export default component.exports